export const TEST_ID = 'kpiTiles';
